import { PimService } from '#Products/services/PimService'
import { usePimStore } from '#Products/store/pimStore'
import { PimSupport } from '#Products/support/PimSupport'

export const usePim = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(PimService)
    },
    get support() {
      return alt.get(PimSupport)
    },
    get store() {
      return usePimStore()
    },
  }
}
